import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { AnchoredMenu } from '@rossum/components/anchored-menu/AnchoredMenu';
import {
  IconCustomBoltRestore,
  IconCustomBorderCornersRestore,
} from '@rossum/ui/icons/tabler';
import {
  Menu,
  MenuItem,
  Stack,
  SvgIcon,
  Typography,
} from '@rossum/ui/material';

type ReProcessMenuProps = {
  onReExtract?: () => void;
  onReAutomate?: () => void;
  children: (state: { isOpen: boolean }) => ReactNode;
  nested?: boolean;
  onParentClose?: () => void;
};

export const ReProcessMenu = ({
  onReExtract,
  onReAutomate,
  children,
  nested,
  onParentClose,
}: ReProcessMenuProps) => (
  <AnchoredMenu
    nested={nested}
    renderContent={({
      anchorEl,
      open,
      onClose,
      anchorOrigin,
      transformOrigin,
    }) => {
      const handleClick = (action?: () => void) =>
        action
          ? () => {
              onClose();
              onParentClose?.();
              action?.();
            }
          : undefined;

      return (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={onClose}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
        >
          <ReProcessMenuItems
            onReExtract={handleClick(onReExtract)}
            onReAutomate={handleClick(onReAutomate)}
          />
        </Menu>
      );
    }}
  >
    {children}
  </AnchoredMenu>
);

const ReProcessMenuItems = ({
  onReExtract,
  onReAutomate,
}: {
  onReExtract?: () => void;
  onReAutomate?: () => void;
}) => {
  const intl = useIntl();

  return (
    <>
      {onReExtract ? (
        <MenuItem onClick={onReExtract} data-cy="re-process-menu-re-extract">
          <Stack direction="row" spacing={1} alignItems="center">
            <SvgIcon fontSize="medium">
              <IconCustomBorderCornersRestore />
            </SvgIcon>
            <Typography>
              {intl.formatMessage({
                id: 'containers.annotationList.selectionPanel.buttons.reExtract',
              })}
            </Typography>
          </Stack>
        </MenuItem>
      ) : null}
      {onReAutomate ? (
        <MenuItem onClick={onReAutomate} data-cy="re-process-menu-re-automate">
          <Stack direction="row" spacing={1} alignItems="center">
            <SvgIcon fontSize="medium">
              <IconCustomBoltRestore />
            </SvgIcon>
            <Typography>
              {intl.formatMessage({
                id: 'containers.annotationList.selectionPanel.buttons.reAutomate',
              })}
            </Typography>
          </Stack>
        </MenuItem>
      ) : null}
    </>
  );
};
